import React, { useEffect, useState } from 'react';
import VectorStudio from './VectorStudio';
import { ApiDataAccess } from '../infrastructure/ApiDataAccess';




export const Home = () => {

    const [dieline, setDieline] = useState(null);

    useEffect(() => {

        const loadDieline = async () => {

            var request = {
                convertingMethodId: 2,
                length: 400,
                width: 200,
                gusset: 80,
                lengthUomId: 15,
                bundleContents: 46,

                zipperId: 2,        
                zipperOffset: 38.1,

                hangholeId: 2,
                hangholeOffset: 6.35
            };

            var dataAccess = new ApiDataAccess("/api/dieline");
            var response = await dataAccess.post('/meta', request);

            console.log('Dieline', JSON.stringify(response));

            console.log(response);
            setDieline(response);           
        }

        loadDieline();

    }, [])




    return (
        <div>

            {dieline &&
                <VectorStudio width={880} height={200} layers={dieline.layers} />
            }

        </div>
    );

}


